import { Card, HStack, Icon, Stack, Text } from '@chakra-ui/react';
import ApplicationErrorView from '@packages/charka-common-ui/graphql/error/application-error-view';
import { useTranslate } from '@tolgee/react';
import { IoChevronBack } from 'react-icons/io5';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import convertStringToRuleService from '../util/convert-string-to-rule-service';
import CreatePrintRuleDialog from './component/create-print-rule-dialog';
import PrintRuleTable from './component/print-rule-table';
import { usePrintRuleAssignment } from './logic/use-print-rule-assignment';
import { usePrintRuleList } from './logic/use-print-rule-list';

export interface PrintRule {
  id: string;
  name: string;
}

export default function PrintRule() {
  const menuId = useParams().menuId ?? '';
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const service = convertStringToRuleService(searchParams.get('service') ?? '');

  const { t } = useTranslate();

  const { data, loading: printRuleLoading, error: printRuleError } = usePrintRuleList(menuId);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const {
    data: assignmentRuleData,
    loading: assignmentLoading,
    error: assignmentError,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  } = usePrintRuleAssignment(menuId, service!);

  if (!service) {
    return <Text>{t('print-rule.not-service', 'Have no selection service')}</Text>;
  }

  const loading = printRuleLoading || assignmentLoading;
  const error = printRuleError ?? assignmentError;
  const printRules = data?.getPrintRuleList.menuPrintRules.map((item) => ({
    id: item.id,
    name: item.name,
  }));

  const printRuleAssigmentId = assignmentRuleData?.getPrintRuleAssignment
    ? assignmentRuleData.getPrintRuleAssignment.menuPrintRuleId
    : null;

  return (
    <>
      <ApplicationErrorView error={error} />

      <Card.Root rounded={'md'}>
        <Card.Header px={4} py={5}>
          <Stack direction={{ base: 'column', lg: 'row' }} justifyContent={'space-between'}>
            <Card.Title fontSize={'2xl'} fontWeight={600}>
              <HStack>
                <Icon
                  onClick={() => {
                    navigate(`..?service=${searchParams.get('service') ?? ''}`);
                  }}
                >
                  <IoChevronBack size={30} />
                </Icon>

                <Stack direction={{ base: 'column', lg: 'row' }}>
                  <Text fontSize={'2xl'}>{data?.getPrintRuleList.title}</Text>
                  <Text fontSize={'2xl'}>({t('print-rule.header', 'Print rule')})</Text>
                </Stack>
              </HStack>
            </Card.Title>
            <CreatePrintRuleDialog />
          </Stack>
        </Card.Header>
        <Card.Body p={0}>
          <PrintRuleTable printRules={printRules} printRuleAssigmentId={printRuleAssigmentId} loading={loading} />
        </Card.Body>
      </Card.Root>
    </>
  );
}
